// Look-back window (in days) for the Energy & Cost overview card. The numeric value is the number
// of days the chart spans and is also what gets persisted to local storage.
export enum EnergyCostRange {
  Last7Days = 7,
  Last14Days = 14,
  Last30Days = 30,
}

export const DEFAULT_ENERGY_COST_RANGE = EnergyCostRange.Last14Days;
